import React, { useState } from "react";
import { fraction } from "mathjs";

const multiplyQuantity = (quantity, multiplier) => {
	return multiplier === 1
		? quantity
		: quantity?.replace(/(\d+[/\d. ]*|\d)/g, (match) => {
				try {
					const hasSpace = match.endsWith(" ");
					match = match.trim();
					const multipliedFraction = new fraction(match).mul(multiplier).toFraction(true);
					return hasSpace ? multipliedFraction + " " : multipliedFraction;
				} catch {
					return match;
				}
		  });
};

const pluralizeMeasurement = (measurement, quantity) => {
	if (!measurement) {
		return "";
	}
	if (Number(quantity) <= 1 || measurement.endsWith("s")) {
		return measurement;
	}
	return `${measurement}s`;
};

export default function Ingredient(props) {
	let { quantity, measurement, ingredient, pre, post } = props.ingredient;

	quantity = multiplyQuantity(quantity, props.multiplier);
	post = multiplyQuantity(post, props.multiplier);
	measurement = pluralizeMeasurement(measurement, quantity);
	let [isComplete, setIsComplete] = useState(false);

	return (
		<label className="checkbox is-checkbox" style={{ userSelect: "none" }}>
			<input
				type="checkbox"
				checked={isComplete}
				onChange={() => setIsComplete(!isComplete)}
			/>
			<span
				style={{
					textDecoration: isComplete ? "line-through" : null,
					opacity: isComplete ? 0.25 : null,
				}}>
				{pre} {quantity} {measurement} {ingredient?.name.trim()} {post}
			</span>
		</label>
	);
}
